<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Proyecto"
            rules="required"
          >
            <b-form-group
              label="Dependencia"
              label-for="proyecto"
              :state="getValidationState(validationContext)"
            >
              <b-form-select
                v-model="proyecto"
                type="select"
                class="custom-select"
              >
                <option value="">
                  SELECCIONE::
                </option>
                <option
                  v-for="proy in optionProyecto"
                  :key="proy.idProyecto"
                  :value="proy.idProyecto"
                >
                  {{ proy.nombre }}
                </option>
              </b-form-select>
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Titutlo"
            rules="required"
          >
            <b-form-group
              label="Título"
              label-for="titulo"
            >
              <b-form-input
                id="titulo"
                v-model="formData.titulo"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Escriba el título de la encuesta.."
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Descripcion"
            rules="required"
          >
            <b-form-group
              label="Descripción"
              label-for="descripción"
            >
              <b-form-textarea
                id="textarea-formatter"
                v-model="formData.descripcion"
                placeholder="Escriba la descripción de la encuesta.."
                rows="4"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="meta"
            rules="required"
          >
            <b-form-group
              label="Meta Mensual"
              label-for="meta"
            >
              <b-form-input
                id="meta"
                v-model="formData.meta"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group>
            <label for="urlGuia">Url Guia </label>
            <small class="text-muted">
              <i
                class="popover-space"
              >
                <feather-icon
                  id="popover-urlguia"
                  icon="InfoIcon"
                  class="mr-50 fa-red"
                  @click="hidePopover"
                />
              </i>
            </small>
            <b-form-input
              id="urlGuia"
              v-model="formData.urlGuia"
              trim
            />
          </b-form-group>
          <b-popover
            target="popover-urlguia"
            placement="top"
            triggers="hover"
          >
            <template #title>
              Definición de Url Guia
            </template>
            <span>
              Registra la url guia , por ejemplo video tutorial de creación de encuestas, manual de uso de sistemas o entre otras cosas.
            </span>
          </b-popover>
          <b-form-group>
            <label for="TipoVista">Tipo Vista </label>
            <small class="text-muted">
              <i
                class="popover-space"
              >
                <feather-icon
                  id="popover-tipovista"
                  icon="InfoIcon"
                  class="mr-50 fa-red"
                  @click="hidePopover"
                />
              </i>
            </small>
            <b-form-select
              v-model="tipoVista"
              type="select"
              class="custom-select"
            >
              <option value="">
                SELECCIONE::
              </option>
              <option value="1">
                ONEPAGE
              </option>
            </b-form-select>
          </b-form-group>
          <b-popover
            target="popover-tipovista"
            placement="top"
            triggers="hover"
          >
            <template #title>
              Definición de Tipo de Vista
            </template>
            <span>
              Registra el tipo de vista como se mostrará y navegará durante la ejecución de la encuesta.
            </span>
          </b-popover>
          <validation-provider
            #default="validationContext"
            name="sourceMultimedia"
            rules="required"
          >
            <b-form-group>
              <label for="sourceMultimedia">Fuente Multimedia</label>
              <small class="text-muted">
                <i
                  class="popover-space"
                >
                  <feather-icon
                    id="popover-galery"
                    icon="InfoIcon"
                    class="mr-50 fa-red"
                    @click="hidePopover"
                  />
                </i>
              </small>
              <b-form-select
                v-model="sourceMultimedia"
                type="select"
                class="custom-select"
              >
                <option value="T">
                  TODOS
                </option>
                <option value="G">
                  GALERÍA
                </option>
                <option value="C">
                  CÁMARA
                </option>
              </b-form-select>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-popover
            target="popover-galery"
            placement="top"
            triggers="hover"
          >
            <template #title>
              Fuente de Multimedia
            </template>
            <span>
              Registra el tipo de fuente de la multimedia
            </span>
          </b-popover>
          <b-form-group
            v-show="false"
          >
            <label class="col-sm-8 control-label">¿Es dinámico?</label>
            <div
              class="col-sm-4 text-right"
              style="display:inline-block !important"
            >
              <b-form-checkbox
                v-model="formData.dinamico"
                checked="true"
                name="check-button"
                switch
                inline
              />
            </div>
          </b-form-group>
          <b-form-group>
            <label class="col-sm-8 control-label">¿Publicado?</label>
            <div
              class="col-sm-4 text-right"
              style="display:inline-block !important"
            >
              <b-form-checkbox
                v-model="formData.publicado"
                checked="true"
                name="check-button"
                switch
                inline
              />
            </div>
          </b-form-group>
          <b-form-group>
            <label class="col-sm-8 control-label">¿Se puede retomar?</label>
            <div
              class="col-sm-4 text-right"
              style="display:inline-block !important"
            >
              <b-form-checkbox
                v-model="formData.esRetomado"
                checked="true"
                name="check-button"
                switch
                inline
              />
            </div>
          </b-form-group>
          <b-form-group>
            <label class="col-sm-8 control-label">¿Es requerido observación?</label>
            <div
              class="col-sm-4 text-right"
              style="display:inline-block !important"
            >
              <b-form-checkbox
                v-model="formData.requeridoObservacion"
                checked="true"
                name="check-button"
                switch
                inline
              />
            </div>
          </b-form-group>
          <b-form-group>
            <label class="col-sm-8 control-label">¿Es requerido multimedia?</label>
            <div
              class="col-sm-4 text-right"
              style="display:inline-block !important"
            >
              <b-form-checkbox
                v-model="formData.requeridoMultimedia"
                checked="true"
                name="check-button"
                switch
                inline
              />
            </div>
          </b-form-group>
          <b-form-group>
            <label class="col-sm-8 control-label">¿Encuestado ingresado manualmente?</label>
            <div
              class="col-sm-4 text-right"
              style="display:inline-block !important"
            >
              <b-form-checkbox
                v-model="formData.encuestadoIngresoManual"
                checked="true"
                name="check-button"
                switch
                inline
              />
            </div>
          </b-form-group>
          <b-form-group>
            <label class="col-sm-8 control-label">Expira</label>
            <div
              class="col-sm-4 text-right"
              style="display:inline-block !important"
            >
              <b-form-checkbox
                v-model="formData.expira"
                checked="true"
                name="check-button"
                switch
                inline
                @change="checkExpira($event)"
              />
            </div>
          </b-form-group>
          <br>
          <b-form-group
            label="Fecha Inicio"
            label-for="fechaInicio"
          >
            <b-form-datepicker
              id="fechaInicio"
              v-model="formData.fechaInicio"
              class="mb-1"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es"
              placeholder="Selecccione fecha"
            />
          </b-form-group>
          <b-form-group
            v-show="showDateExpira"
            label="Fecha Final"
            label-for="fechaFin"
          >
            <b-form-datepicker
              id="fechaFin"
              v-model="formData.fechaFin"
              class="mb-1"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es"
              placeholder="Selecccione fecha"
            />
          </b-form-group>
          <br>
          <b-row class="container">
            <b-col md="4">
              <b-media class="mb-2 text-center">
                <template #aside>
                  <b-avatar
                    ref="previewEl"
                    :src="imgBase64"
                    :text="avatarText(imgBase64)"
                    size="100px"
                    rounded=""
                  />
                </template>
              </b-media>
            </b-col>
            <b-col md="8">
              <b-row class="mt-1">
                <b-col md="12">
                  <b-button
                    variant="success"
                    class="btn-block btn-sm"
                    @click="$refs.refInputEl.$el.click()"
                  >
                    <b-form-file
                      id="file"
                      ref="refInputEl"
                      v-model="fileLogo"
                      accept=".jpg, .png, .gif"
                      :hidden="true"
                      plain
                      @input="inputImageRenderer"
                      @change="uploadFile"
                    />
                    <!-- <input
                      id="file"
                      ref="refInputEl"
                      type="file"
                      v-model="fileLogo"
                      class="d-none"
                      @input="inputImageRenderer"
                      v-on:change="uploadFile"
                    > -->
                    <span class="d-none d-sm-inline">Subir Imagen</span>
                    <feather-icon
                      icon="EditIcon"
                      class="d-inline d-sm-none"
                    />
                  </b-button>
                </b-col>
              </b-row>
              <b-row style="padding-top:10px">
                <b-col md="12">
                  <b-button
                    variant="danger"
                    class="btn-block btn-sm"
                    @click="onDeleteImagen"
                  >
                    <span class="d-none d-sm-inline">Eliminar Imagen</span>
                    <feather-icon
                      icon="TrashIcon"
                      class="d-inline d-sm-none"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <div class="d-flex mt-3">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormSelect, BMedia, BAvatar, BRow, BCol, BFormFile, BFormTextarea, BFormCheckbox, BFormDatepicker, VBPopover, BPopover,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import moment from 'moment'
import { avatarText } from '@core/utils/filter'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { useNotify } from '@/helpers/toast'
// import useUsersList from '../users-list/useUsersList'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormSelect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormFile,
    BFormTextarea,
    BFormCheckbox,
    BFormDatepicker,
    BPopover,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    formType: {
      type: String,
      required: true,
    },
    imgLogo: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      required,
      avatarText,
    }
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const refInputEl = ref(null)
    const previewEl = ref(null)
    const imgBase64 = ref(null)
    const showDateExpira = ref(false)
    const departamento = ref('')
    const optionProyecto = ref([])
    const proyecto = ref('')
    const titleForm = ref('')
    const imgName = ref('')
    const isBusy = ref(false)
    const userData = ref(JSON.parse(localStorage.getItem('userData')))
    // const esRetomado = ref(false)
    const showPopover = () => {
      context.emit('bv::show::popover', 'popover-urlguia')
    }
    const hidePopover = () => {
      context.emit('bv::hide::popover', 'popover-button-2')
    }
    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      // eslint-disable-next-line no-param-reassign
      imgBase64.value = base64
      // props.imgLogo = base64
    })

    const blankData = {
      idEncuesta: 0,
      titulo: '',
      descripcion: '',
      urlGuia: '',
      tipoVista: '',
      sourceMultimedia: 'T',
      expira: false,
      dinamico: false,
      publicado: false,
      logo: null,
      fechaInicio: moment().format('YYYY-MM-DD'),
      fechaFin: '',
      meta: 1,
      esRetomado: false,
      requeridoObservacion: false,
      requeridoMultimedia: false,
      encuestadoIngresoManual: false,
    }
    const blankSelect = ''
    const tipoVista = ref('')
    const sourceMultimedia = ref('T')
    const fileLogo = ref(null)
    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
      proyecto.value = JSON.parse(JSON.stringify(blankSelect))
      tipoVista.value = JSON.parse(JSON.stringify(blankSelect))
      sourceMultimedia.value = JSON.parse(JSON.stringify(blankSelect))
    }

    const onDeleteImagen = () => {
      imgBase64.value = null
    }
    const uploadFile = e => {
      const fileTemp = e.target.files[0]
      fileLogo.value = fileTemp
    }
    const onSubmit = () => {
      let bval = true
      isBusy.value = true
      formData.value.proyecto = {
        idProyecto: proyecto.value,
      }
      formData.value.logo = (fileLogo.value !== null) ? fileLogo.value : null
      if (formData.value.logo === null && (imgName.value === null || imgName.value === '')) {
        notify('Advertencia', 'Adjuntar logo', 'warning')
        bval = false
        isBusy.value = false
      }
      if (bval) {
        formData.value.tipoVista = tipoVista.value
        formData.value.sourceMultimedia = sourceMultimedia.value
        let service = 'gsencuesta/ENCUESTA_CREATE'
        if (props.formType === 'edit') {
          service = 'gsencuesta/ENCUESTA_UPDATE'
        }
        store.dispatch(service, formData.value)
          .then(response => {
            isBusy.value = false
            context.emit('refetch-data', response)
            context.emit('update:is-add-new-user-sidebar-active', false)
          })
          .catch(error => {
            isBusy.value = false
            context.emit('error-data', error)
            notify('Ha ocurrido un error', error.response.data.message, 'danger')
          })
        fileLogo.value = null
        document.getElementById('file').value = ''
      }
    }
    const dataForm = () => {
      store
        .dispatch('gsencuesta/PROYECTO_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          // sortBy: '',
          sortBy: 'idProyecto%7CDESC',
          idInstitucion: userData.value.idInstitucion,
        })
        .then(response => {
          if (response !== undefined) {
            optionProyecto.value = response
            proyecto.value = userData.value.idProyecto
          }
        })
        .catch(() => {
        })
    }
    const getLogo = data => {
      store
        .dispatch('gsencuesta/ENCUESTA_FIND_LOGO', {
          idEncuesta: data.idEncuesta,
        })
        .then(response => {
          imgBase64.value = `data:image/png;base64,${Buffer.from(response, 'binary').toString('base64')}`
        })
        .catch(() => {
          // console.log(error)
        })
    }
    const checkExpira = value => {
      if (value) {
        showDateExpira.value = true
        formData.value.fechaFin = moment().format('YYYY-MM-DD')
      } else {
        showDateExpira.value = false
        formData.value.fechaFin = ''
      }
    }
    const toggleSidebar = val => {
      showDateExpira.value = false
      dataForm()
      context.emit('update:is-add-new-user-sidebar-active', val)
      proyecto.value = ''
      imgName.value = ''
      imgBase64.value = null /* INICIALIZANDO LOGO */
      fileLogo.value = null
      document.getElementById('file').value = ''
      sourceMultimedia.value = 'T'

      if (props.formType === 'new') {
        titleForm.value = 'Agregar Encuesta'
      }
      if (props.formType === 'edit') {
        formData.value = {
          idEncuesta: props.dataEdit.idEncuesta,
          titulo: props.dataEdit.titulo,
          descripcion: props.dataEdit.descripcion,
          urlGuia: props.dataEdit.urlGuia,
          dinamico: props.dataEdit.dinamico,
          expira: props.dataEdit.expira,
          fechaFin: props.dataEdit.fechaFin,
          publicado: props.dataEdit.publicado,
          fechaInicio: props.dataEdit.fechaInicio,
          meta: props.dataEdit.meta,
          esRetomado: props.dataEdit.esRetomado,
          requeridoObservacion: props.dataEdit.requeridoObservacion,
          requeridoMultimedia: props.dataEdit.requeridoMultimedia,
          encuestadoIngresoManual: props.dataEdit.encuestadoIngresoManual,
          logo: (props.dataEdit.logo) ? props.dataEdit.logo : null,
        }
        getLogo(props.dataEdit)
        tipoVista.value = props.dataEdit.tipoVista
        sourceMultimedia.value = props.dataEdit.sourceMultimedia
        proyecto.value = props.dataEdit.proyecto.idProyecto
        imgName.value = (props.dataEdit.logoName) ? props.dataEdit.logoName : null
        if (props.dataEdit.expira) {
          showDateExpira.value = true
        }
        titleForm.value = 'Editar Encuesta'
      }
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      formData,
      showDateExpira,
      optionProyecto,
      titleForm,
      departamento,
      checkExpira,
      toggleSidebar,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      proyecto,
      fileLogo,
      refInputEl, // PARA RELACIONAR BOTON CON INPUT FILE
      inputImageRenderer,
      previewEl,
      imgBase64,
      onDeleteImagen,
      uploadFile,
      tipoVista,
      sourceMultimedia,
      showPopover,
      hidePopover,
      isBusy,
      imgName,
      userData,
    }
  },
  methods: {
    openLogo(item) {
      if (item.logo) {
        window.open(item.logo)
      } else {
        this.$bvToast.toast('Error', {
          title: 'He ocurrido un error',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
.popover-space {
  margin-left: 1%;
  cursor: pointer;
}
</style>
